export const ENTITY_TYPE_PROVIDER = "Provider";
